import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { Route, Switch } from 'react-router-dom';
import AdminLayout from '@/components/layouts/Admin';
import { observer } from 'mobx-react';
import { AuthenticationStoreContext } from '@/stores/authentication.store';
import { isGuarded } from '@utils/routes.util';
import { removeFromStorage } from '@utils/storage.util';
import DefaultLayout from '@components/layouts/Default';
import PageNotFound from '@/pages/PageNotFound';

const Router = () => {
  const location = useLocation();
  const authStore = React.useContext(AuthenticationStoreContext);
  const history = useHistory();
  const [isChecked, setIsChecked] = React.useState<boolean>(false);

  const checkAuth = React.useCallback(async () => {
    if (location.pathname.includes('/confirm-change-email')) {
      removeFromStorage('token');
    }
    const existedToken = localStorage.getItem('token');

    if (!existedToken && isGuarded(location.pathname)) {
      history.push('/');
    }
    if (existedToken && !authStore.loggedUser) {
      await authStore.validateToken(existedToken);
    }

    setIsChecked(true);

    if (
      existedToken &&
      authStore.loggedUser &&
      authStore.loggedUser?.role < 2
    ) {
      return history.push('/');
    }
  }, [authStore, authStore.loggedUser, history]);

  React.useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <>
      {isChecked ? (
        <Switch>
          {authStore?.loggedUser != null && authStore?.loggedUser?.role > 1 && (
            <Route
              path="/*"
              render={(props: any) => <AdminLayout {...props} exact />}
            />
          )}
          <Route
            path="/"
            render={(props: any) => <DefaultLayout {...props} exact />}
          />
        </Switch>
      ) : (
        <PageNotFound />
      )}
    </>
  );
};

export default observer(Router);
